class SystemsGroupsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#groups-datatable', organizationID);
        this.organizationID = organizationID;
        this.initActions(organizationID);
    }
    init(el, organizationID){
        let thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 500,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '?do=getSystemsGroups',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=groups-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'name',
                    title: 'Group',
                    sortable: true,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        return new GroupInfoGenerator().generateSystemTableView(row['name'], row['edit'], row['uuid'], row['systems'].length)
                    }
                },
                {
                    data: 'accessCards',
                    title: 'Access cards',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '';
                        for (let i = 0; i < row['accessCards'].length; i++) {
                            if(row['edit']){
                                html += '<span class="badge badge-danger me-1 mb-1 cursor-pointer text-hover-white bg-hover-danger edit-access-card" id="'+row['accessCards'][i]['uuid']+'">'+row['accessCards'][i]['name']+'</span>';
                            } else {
                                html += '<span class="badge badge-danger me-1 mb-1">'+row['accessCards'][i]['name']+'</span>';
                            }
                        }
                        return html;
                    }
                },
                {
                    data: 'systems',
                    title: 'Systems',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        if(row['systems']){
                            for (let i = 0; i < row['systems'].length; i++) {
                                let iconUrl = '/media/goodaccess/icons/system/'+row['systems'][i]['iconID']+'.svg';
                                let serviceHtml = '';
                                if(row['systems'][i]['isAdvanced']){
                                    serviceHtml = new ServiceTooltip().getHtml(row['systems'][i]['services']);
                                }
                                if (i < 3) {
                                    html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" '+ (row['systems'][i]['edit'] ? ' id="'+row['systems'][i]['uuid']+'"' : '') +'>' +
                                        '        <div class="symbol-label bg-light-primary border border-2 border-white'+(!row['systems'][i]['isValid'] || row['systems'][i]['isIsolated'] ? ' filter-grayscale' : '')+ (row['systems'][i]['edit'] ? ' edit-system' : '') +'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center fw-bold\'>'+row['systems'][i]['name']+(row['systems'][i]['customUri'] ? '' : '<i class=\'fa-solid fa-eye-slash ga-text-primary-700 ms-2\'></i>')+'</div><div class=\'text-center\'>'+(row['systems'][i]['customUri'] ? row['systems'][i]['customUri'] : row['systems'][i]['host'])+'</div>'+(row['systems'][i]['isAdvanced'] ? '<div class=\'text-center\'>'+row['systems'][i]['services'].length+' services</div>' : '')+'">'+
                                        '             <img alt="avatar" class="h-40px" src="' + iconUrl + '"/>' +
                                        '        </div>' +
                                        (serviceHtml !== '' ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+serviceHtml+'">'+row['systems'][i]['services'].length+'</span>' : '')+
                                        (!row['systems'][i]['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                                        (row['systems'][i]['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                                        '</div>';
                                } else {
                                    html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['systems'].length - 3)+' more systems</div>">' +
                                        '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-system-group' : '') +'">+'+(row['systems'].length - 3)+'</div>'+
                                        '     </div>';
                                    break;
                                }
                            }
                        }
                        return html+'</div>';
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="'+row['uuid']+'">';
                        let editHtml = '';
                        if (row['edit']) {
                            editHtml += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-system-group" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                '           <span class="svg-icon svg-icon-3">' +
                                '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                                '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                                '               </svg>' +
                                '           </span>' +
                                '       </div>';
                            html += editHtml + '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-system-group cursor-pointer" '+(row['accessCards'].length > 0 ? 'data-access-cards="true"' : '')+' data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('draw', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#groups-datatable_wrapper').hide();
                $('#groups-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#groups-datatable_wrapper').show();
                $('#groups-datatable_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
            }
        });
        // Add delay to datatable search
        new DatatableSearchDelay(datatable, '#groups_tab [data-kt-docs-table-filter=search]');
        return datatable;
    }
    initActions(organizationID){
        const thisClass = this;
        $(document).on('click','#groups-datatable .delete-system-group',function(e){
            let groupID = $(this).parent()[0].id;
            let accessCards = $(this).attr('data-access-cards');
            let groupName = $(this).closest('tr').find('span[data-group-name]').attr('data-group-name');
            let html = '';
            if(accessCards !== undefined){
                html += `<span class="text-center text-primary">Group `+(groupName !== undefined ? `<b>`+groupName+`</b> ` : ``)+`is going to be completely deleted! Deleting this Group will affect the access rights of Systems in this Group.</span>`;
            } else {
                html += `<span class="text-center text-primary">Group `+(groupName !== undefined ? `<b>`+groupName+`</b> ` : ``)+`is going to be completely deleted!</span>`;
            }
            Swal.fire({
                html: html,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/systems?do=removeSystemGroup&organizationID='+organizationID+'&systemGroupID='+groupID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Group has been deleted.');
                        thisClass.datatable.ajax.reload(null, false);
                        $('#systems-datatable').DataTable().ajax.reload(null, false);
                        let numberOfGroupsElement = $(".systems-tab-menu .number-of-system-groups");
                        let numberOfGroups = parseInt(numberOfGroupsElement.text());
                        numberOfGroupsElement.text(numberOfGroups-1);
                    }
                }
            });
        });
    }
}
window.SystemsGroupsDatatable = SystemsGroupsDatatable;